import { Avatar, Box, Button, Divider, Typography } from "@mui/material";
import React from "react";
import { FaTasks, FaUser } from "react-icons/fa";
import { BsClipboardData } from "react-icons/bs";
import { AiFillStar } from "react-icons/ai";
import { femaleAvatar, maleAvatar } from "../iconsImports";

const EmployeeCard = ({ employee }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        maxWidth: "700px",
        width: "100%",
        backgroundColor: "#fff",
        gap: "20px",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          width: "150px",
          gap: "12px",
        }}
      >
        <Avatar
          alt={employee.name}
          src={employee.gender === "Male" ? maleAvatar : femaleAvatar}
          sx={{ width: 90, height: 90 }}
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            fontSize: "0.9rem",
            color: "#666",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <BsClipboardData style={{ color: "#B58EFD" }} />
            <span>04</span>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <AiFillStar style={{ color: "#FFD700" }} />
            <span>4.5</span>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <BsClipboardData style={{ color: "#FF6B6B" }} />
            <span>04</span>
          </Box>
        </Box>
        <Typography sx={{ fontWeight: 600, color: "#2C3E50" }}>
          {employee.name}
        </Typography>
      </Box>

      <Divider
        orientation="vertical"
        flexItem
        sx={{ mx: 2, bgcolor: "#ddd" }}
      />

      <Box sx={{ flex: 1, minWidth: "250px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              fontSize: "1rem",
              color: "#000",
              backgroundColor: "#EEE5FF",
              padding: "6px 14px",
              borderRadius: "8px",
              width: "fit-content",
              fontWeight: "bold",
            }}
          >
            {employee.sub_role}
          </Box>

          <Box sx={{ width: "100%", mt: 1 }}>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{ bgcolor: "#ddd" }}
            />
            <Typography
              variant="body2"
              sx={{
                color: "#555",
                fontSize: "0.9rem",
                mt: 1,
                fontStyle: "italic",
                textAlign: "justify",
              }}
            >
              <strong>{employee.name}</strong> is a skilled{" "}
              <strong>{employee.sub_role}</strong> specializing in{" "}
              {employee.sub_role === "FRONTEND DEVELOPER"
                ? "HTML, CSS, JavaScript, React.js,Typescript and Next.js."
                : employee.sub_role === "BACKEND DEVELOPER"
                ? "Node.js, Express.js, MongoDB, SQL, and API development."
                : employee.sub_role === "APP DEVELOPER"
                ? "Flutter, React Native, Kotlin, and Swift."
                : "various technologies."}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: "12px", mt: 2, flexWrap: "wrap" }}>
          <Button
            variant="contained"
            startIcon={<FaTasks />}
            sx={{
              backgroundColor: "#2F3B57",
              color: "#fff",
              textTransform: "none",
              "&:hover": { backgroundColor: "#1e2a3f" },
              flex: 1,
              minWidth: "120px",
            }}
          >
            Add Task
          </Button>
          <Button
            variant="contained"
            startIcon={<FaUser />}
            sx={{
              backgroundColor: "#2F3B57",
              color: "#fff",
              textTransform: "none",
              "&:hover": { backgroundColor: "#1e2a3f" },
              flex: 1,
              minWidth: "120px",
            }}
          >
            Profile
          </Button>
        </Box>
      </Box>

      <style>{`
        @media (max-width: 768px) {
          div {
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 15px;
          }
          .divider {
            display: none;
          }
        }
      `}</style>
    </Box>
  );
};

export default EmployeeCard;
